<template>
  <p class="search-bar flex align-center" @click="goSearch" v-if="canSearch">
    <icon-font
      style="font-size: 14px; vertical-align: middle; margin-right: 8px"
      icon-name="iconsousuo"
    />
    输入药品、疾病、症状
  </p>
</template>
<script>
export default {
  computed: {
    canSearch() {
      let show = this.env.inAPP;
      if (this.env.inAPP) {
        try {
          const version = Number(Sailer.getVersion().replace(/\./g, ''));
          show = version >= 5130;
        } catch {
          // do nothing
        }
      }
      return show || this.env.inWechatMiniProgram;
    },
  },
  methods: {
    goSearch() {
      if (this.env.inWechatMiniProgram) {
        window.wx.miniProgram.navigateTo({
          url: `/pages_independent/pages/search/SearchResult?isShowHistory=1&from=index`,
        });
        return;
      }
      if (this.env.inAPP) {
        this.adapter.open('native://page-main-search');
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-bar {
  line-height: 36px;
  background: #ffffff;
  border-radius: 20px;
  color: #bfbfbf;
  padding: 0 12px;
}
</style>
